export const CMP_LISTING_LIB_CACHE_FIRST_VIEW_OPTIMIZATION = 'CMP_LISTING_LIB_CACHE_FIRST_VIEW_OPTIMIZATION';